<template>
  <q-card flat>
    <q-card-section>
      <q-btn flat round icon="print" color="indigo" @click="loadReport" />
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          :data="rewards"
          row-key="id"
          wrap-cells
          :hide-header="$q.screen.lt.md"
          flat
          :rows-per-page-options=[100]>
        <template v-slot:header>
          <q-tr class="text-center text-bold">
            <td>تاریخ</td>
            <td>نوع کرایه</td>
            <td>پاداش(ریال)</td>
          </q-tr>
          <q-tr class="text-center text-bold">
            <td></td>
            <td></td>
            <td class="text-center text-green">
              <q-chip square color="green" text-color="white" :label="lodash.sumBy(rewards, item=> item.Reward).toLocaleString()" />
            </td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="text-center">
            <td class="text-center text-bold">{{props.row.RegisterDate}}</td>
            <td class="text-center text-bold">
              {{props.row.TransferType==='Indoor'?'درون شهری':'برون شهری'}}</td>
            <td class="text-center text-green text-bold">
              {{props.row.Reward.toLocaleString()}} ریال
              <q-tooltip content-class="bg-transparent">
                <q-card class="shadow-9">
                  <q-card-section class="no-padding">
                    <q-banner dense inline-actions class="bg-blue text-white">
                      جزییات پاداش
                    </q-banner>
                  </q-card-section>
                  <q-card-section>
                    <q-banner rounded class="bg-deep-orange text-white">
                      مشتری فعال، مشتری است که به اندازه سقف تعیین شده در هدف فاکتور داشته باشد
                    </q-banner>
                  </q-card-section>
                  <q-card-section >
                    <q-chip label="تعداد مشتری جدید" square color="indigo" text-color="white">
                      <q-badge floating :label="props.row.NewCustomer" color="red" text-color="white" />
                    </q-chip>
                    <q-chip label="تعداد بازدید" square color="indigo" text-color="white">
                      <q-badge floating :label="props.row.TotalRegisterCount" color="red" text-color="white" />
                    </q-chip>
                    <q-chip label="مشتریان فعال" square color="indigo" text-color="white">
                      <q-badge floating :label="props.row.SaleRegisterCount" color="red" text-color="white" />
                    </q-chip>
                    <q-chip label="مشتریان غیرفعال" square color="indigo" text-color="white">
                      <q-badge floating :label="props.row.NotSaleRegisterCount" color="red" text-color="white" />
                    </q-chip>
                  </q-card-section>
                </q-card>
              </q-tooltip>
            </td>
          </q-tr>
        </template>
      </q-table>

    </q-card-section>

  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'Rewards',
  components: {},
  props:{
    startDate:{
      type: String,
      required: true,
      default: ()=> undefined
    },
    endDate:{
      type: String,
      required: true,
      default: ()=> undefined
    },
    userId:{
      type: Number,
      required: true,
      default: ()=> -1
    }
  },
  data(){
    return{
      rewards:[]
    }
  },
  methods:{
    ...mapActions({
      setRewards: 'Agents/getVisitorRewardByCustomerRegister'
    }),
    async loadReport() {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات بازاریابان/گزارش کارکرد ماهانه بازاریابان?rs:Format=PDF&StartDate=${this.startDate}&EndDate=${this.endDate}&UserID=${this.userId}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
  },
  created() {
    this.setRewards({
      startDate: this.startDate.replaceAll('/','-'),
      endDate: this.endDate.replaceAll('/','-'),
      userId:this.userId
    }).then((res)=>{
      this.rewards = res
    })
  }
}
</script>